/* eslint-disable i18next/no-literal-string -- styles not user facing */
import { defineSlotRecipe } from '@chakra-ui/react';

export const card = defineSlotRecipe({
  className: 'chakra-card',
  slots: ['root', 'title', 'description', 'header', 'body', 'footer'],
  base: {
    root: {
      display: 'flex',
      flexDirection: 'column',
      position: 'relative',
      minWidth: '0',
      wordWrap: 'break-word',
      borderRadius: 'none',
      color: 'fg',
      textAlign: 'start',
    },
    title: {
      fontWeight: 'bold',
    },
    description: {
      color: 'fg.muted',
      fontSize: 'sm',
    },
    header: {
      paddingInline: 'var(--card-padding)',
      paddingY: 'var(--card-padding)',
      display: 'flex',
      flexDirection: 'column',
      gap: '1.5',
      borderBottom: '1px solid',
      borderColor: 'border',
      _dark: {
        borderBottom: 'none',
        paddingTop: 'var(--card-padding)',
        paddingBottom: '0',
      },
    },
    body: {
      padding: 'var(--card-padding)',
      flex: '1',
      display: 'flex',
      flexDirection: 'column',
      overflow: 'auto',
    },
    footer: {
      display: 'flex',
      alignItems: 'center',
      gap: '2',
      paddingInline: 'var(--card-padding)',
      paddingY: 'var(--card-padding)',
      borderTop: '1px solid',
      borderColor: 'border',
    },
  },
  variants: {
    size: {
      sm: {
        root: {
          '--card-padding': 'spacing.4',
        },
        title: {
          textStyle: 'md',
        },
      },
      md: {
        root: {
          '--card-padding': 'spacing.6',
        },
        title: {
          textStyle: 'xl',
          lineHeight: 1.2,
        },
      },
      lg: {
        root: {
          '--card-padding': 'spacing.7',
        },
        title: {
          textStyle: 'xl',
        },
      },
    },

    variant: {
      elevated: {
        root: {
          bg: 'bg.panel',
          boxShadow: 'md',
          _dark: {
            borderRadius: 'md',
          },
        },
      },
      outline: {
        root: {
          bg: 'bg.panel',
          borderWidth: '1px',
          borderColor: 'border',
        },
      },
      subtle: {
        root: {
          bg: 'bg.muted',
        },
      },
    },
  },
  defaultVariants: {
    variant: 'outline',
    size: 'md',
  },
});
